import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './NewsPreview.css';

const NewsPreview = ({ onNavigate }) => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    const newsRef = ref(database, 'news');
    const unsubscribe = onValue(newsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setNews(list.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0)));
      } else {
        setNews([]);
      }
    });
    return () => unsubscribe();
  }, []);

  const displayNews = news.slice(0, 3);
  const formatDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <section id="haber" className="news-preview">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Haberler</h2>
          <p className="section-subtitle">Güncel haber ve duyurular</p>
        </div>
        {news.length === 0 ? (
          <p className="news-preview-empty">Henüz haber yok.</p>
        ) : (
          <>
            <div className="news-preview-grid">
              {displayNews.map((item) => (
                <article key={item.id} className="news-preview-card">
                  <h3 className="news-preview-title">{item.title}</h3>
                  {item.date && <time className="news-preview-date">{formatDate(item.date)}</time>}
                  <p className="news-preview-excerpt">{item.excerpt || item.content}</p>
                </article>
              ))}
            </div>
            {onNavigate && (
              <div className="news-preview-cta">
                <button type="button" className="view-all-btn" onClick={() => onNavigate('news')}>
                  Tümünü görüntüle
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default NewsPreview;
